<template>
  <div class="category-filter-section">
    <div class="category-list">
      <button
        v-for="cat in categories"
        :key="cat.id"
        :class="['category-pill', { active: activeCategory === cat.id }]"
        @click="$emit('select-category', cat.id)"
        type="button"
      >
        <span class="category-icon">{{ cat.icon }}</span>
        <span class="category-name">{{ cat.name }}</span>
        <span class="recipe-count" v-if="getCount(cat.id) !== undefined">
          {{ getCount(cat.id) }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilter',
  props: {
    categories: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: String,
      default: 'alla'
    },
    counts: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['select-category'],
  methods: {
    getCount(categoryId) {
      return this.counts[categoryId];
    }
  }
}
</script>

<style scoped>
.category-filter-section {
  padding: 20px 0 10px 0;
}

.category-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 8px;
  padding-top: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.category-list::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.category-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px; /* Bekvämt pekmått för mobiler */
  padding: 10px 18px;
  background-color: var(--color-card-bg);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-lg);
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--color-text-main);
  white-space: nowrap;
  box-shadow: var(--shadow-sm);
  touch-action: manipulation;
  flex-shrink: 0;
}

.category-pill:hover {
  border-color: var(--color-primary);
  transform: translateY(-1px);
}

.category-pill:active {
  transform: scale(0.97);
}

.category-pill.active {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(230, 81, 0, 0.3);
}

.category-icon {
  font-size: 1.15rem;
  line-height: 1;
}

.recipe-count {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  background-color: var(--color-bg-body);
  color: var(--color-text-muted);
}

.category-pill.active .recipe-count {
  background-color: rgba(255, 255, 255, 0.25);
  color: #ffffff;
}

@media (max-width: 640px) {
  .category-filter-section {
    padding: 14px 0 6px 0;
  }
  .category-pill {
    padding: 8px 14px;
    font-size: 0.9rem;
    min-height: 40px;
  }
}
</style>
